import { useEffect, useState } from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";
import UFOSegment from "@atlassian/wac-ufo-segment";

import {
    Cross,
    DataEventProps
} from "../../../../libraries/wpl/foundations/src/index";
import { Link } from "../../link/src";

export interface BannerProps {
    identifier: string;
    text: string;
    linkUrl: string;
    linkText: string;
    dataEventProps?: DataEventProps;
}

const containerStyles = css`
    background-color: #deebff;
    position: relative;
    padding-right: ${token("space.300")};
    margin: auto;
    display: flex;
    z-index: 1;

    &[data-dismissed="true"] {
        display: none;
    }
`;

const contentStyles = css`
    margin: auto;
    padding-left: ${token("space.400")};
    padding-right: ${token("space.800")};
    display: grid;
    color: #091e42;

    a {
        svg {
            transition: transform 0.25s ease-in-out;
        }
    }

    a:hover {
        color: #0065ff;
        text-decoration: none;
        text-shadow: none;

        svg {
            transform: translateX(${token("space.075")});
        }
    }
`;

const closeIconStyles = css`
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    padding: 0;
    position: absolute;
    right: 30px;
    top: ${token("space.200")};

    svg {
        color: #505f79;
    }
`;

export const BannerAlert = ({
    identifier,
    text,
    linkText,
    linkUrl,
    dataEventProps
}: BannerProps) => {
    const intl = useIntl();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;

    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });

    const [isHidden, setIsHidden] = useState<boolean>(true);

    useEffect(() => {
        const dismissValue = localStorage.getItem(bannerStorageItem);

        if (dismissValue !== "1") {
            setIsHidden(false);
        }
    }, []);

    return (
        <UFOSegment name="banner-alert">
            <div
                css={containerStyles}
                data-dismissed={isHidden ? "true" : undefined}
            >
                <button
                    aria-label={translatedLabel}
                    css={closeIconStyles}
                    onClick={() => {
                        setIsHidden(true);
                        localStorage.setItem(bannerStorageItem, "1");
                    }}
                >
                    <Cross size="20" />
                </button>

                <div css={contentStyles}>
                    <p>
                        <span>{text}</span>&nbsp;
                        <Link
                            customLinkColor="b400"
                            text={linkText}
                            href={linkUrl}
                            type="inline-basic"
                            dataEventProps={dataEventProps}
                        />
                    </p>
                </div>
            </div>
        </UFOSegment>
    );
};
